import { OutlineButton, Tooltip, Callout, Label, EventHandler } from "client/CommonComponents";
import { Spinner } from "@softura/fluentuipackage";
import { useEffect, useState } from "react";
import ArrowDown from "client/assets/images/arrowDown.png";
import close from "client/assets/images/Close_SuccessPopup.svg";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { useDispatch } from "react-redux";
import './AttachmentCommonUpload.scss';
import { CONSTANTS } from "client/utils/constants";
interface IProps {
  updateAttachments?: Function;
  accept?: string;
  link?: any;
  tooltipConent?: any;
  isAttachmentsRequired?: boolean,
  reasonAttachment?: any;
  multiple?: any,
  onFileUpload?: any,
  uploadBtnLoading?: boolean;
  error?: string;
  onRemove?: any;
  uploadBtnClick?: any,
  uploadedList?: any,
  list?: any,
  setList?: any
  maxSize?: any
  setError?: any,
  iAttachmentEditable?:any
  disabled?: boolean,
  targetId?: string,
  isDownloadable?: boolean;
  isChangesBeingTracked?: boolean;
  isRequiredError?: boolean;
  OrderRequestType?: string;
}
const DEFAULT_ACCEPT = ".xlsx,.xls,.doc,.docx,.odt,.ods,.ppt,.pptx,.pdf,.htm,.html,.jpeg,.jpg,.jpe,.jif,.jfif,.jfi,.png,.gif,.webp,.tiff,.tif,.psd";
const AttachmentCommonComponent = ({ link, tooltipConent,
  isAttachmentsRequired, multiple,
  accept = DEFAULT_ACCEPT,
  uploadBtnClick,
  uploadBtnLoading = false,
  error,
  onRemove,
  uploadedList,
  list,
  setList,
  maxSize,
  setError,
  iAttachmentEditable,
  disabled,
  targetId,
  isDownloadable,
  isChangesBeingTracked = true,
  isRequiredError = false,
  OrderRequestType,
}: IProps) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState<boolean>(false);
  const handleAttachmentClick = () => setVisible((prev) => !prev);
  const isValidFormat = (file: File) => {
    const extension = file.name.split(".").at(-1) || "";

      return accept.split(",").includes(`.${extension.toLowerCase() }`);
  };

  useEffect(() => {
    setList(uploadedList);
  }, [uploadedList]);

  useEffect(() => {
    if (!visible) {
      setList(uploadedList);
    }
    setError("")
  }, [visible]);

  const setListExt = (file: File) => {
    if (isValidFormat(file)) {
      if (multiple) {
        setList((prev: any) => [...prev, file]);
      } else {
        setList([file]);
      }
    } 
  };

  const onRemoveExt = (index: number) => {
    dispatch(RequisitionAction?.setIsChangesOccured(isChangesBeingTracked))
    onRemove(index);
  };

  const handleDrop = (ev: React.DragEvent<HTMLInputElement>) => {
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      [...ev.dataTransfer.items]
        .filter((item) => item.kind === "file")
        .forEach((item) => {
          const file = item.getAsFile();
          if (file) {
            setListExt(file);
          }
        });
    } else {
      [...ev.dataTransfer.files].forEach(setListExt);
    }
  };

  const isValidSize = (file: File) => {
    const size = file.size / (1024 * 1024);
    return size < maxSize

  }

  const onFileUpload = ({
    target: { files },
  }: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(RequisitionAction?.setIsChangesOccured(isChangesBeingTracked))
    if (files?.length) {
      let attachment = [];
      [...files].forEach((i: any) => {
        setError("")
        const attachmentObj = list?.find((item: any) => item?.name === i?.name);
        if (attachmentObj) {
          attachment.push(attachmentObj)
        }
      })
      let validFiles: any = [...files].filter((file: File) => isValidFormat(file));
      if (attachment?.length) {
        setError("Please Try to add Unique Files")
        validFiles = validFiles.filter((i: any) => !list?.find((item: any) => item?.name === i?.name));
      }
      if (maxSize && validFiles.length) {
        validFiles = validFiles.filter((file: File) => isValidSize(file))
        if (!validFiles.length) {
          setError("File size should not exceed 5MB");
        }
      }
      if (validFiles.length) {
        if (multiple) {
          if (validFiles.length <= 5) {
            setList((prev: any) => [...prev, ...validFiles]);
          } else {
            setList((prev: any) => [...prev, ...validFiles]);
            setError("Please Upload files without exceeding maximum limit of 5 files");
          }
        } else {
          setList([validFiles[0]]);
        }
      }
    }
  };

  const onUpload = (event: any) => {
    dispatch(RequisitionAction?.setIsChangesOccured(isChangesBeingTracked))
    event.stopPropagation();
    event.preventDefault();
    uploadBtnClick(list);
    if (error && list.length) {
      setVisible(true)
    }
  };

  const onDragOver = (event: React.DragEvent<HTMLInputElement>) => {
    dispatch(RequisitionAction?.setIsChangesOccured(isChangesBeingTracked))
    event.stopPropagation();
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
  };

  const onClickAttachment = (item: any) => {
    let win = window.open();
    if (win) {
      win.document.write(
        '<iframe width="100%" height="100%" src="' +
        item +
        '" frameborder="0" ></iframe>'
      );
    }
  };

  return (
    <div className="attachments_contents">
          {link ?
              <><EventHandler onEvent={handleAttachmentClick} data-attribute="index_Default_EventHandler"><span className={isRequiredError ? 'title attachment-btn link-attachment-error' : 'title attachment-btn'} id={targetId || "attachments"}>
          Attachments ({uploadedList?.length}) <span className='fa fa-angle-down'></span>
          {isAttachmentsRequired ? <span className='required'>*</span> : null}
              </span></EventHandler></> :
        <OutlineButton
          text={`Attachments (${+list?.length})`}
          className="attachment-btn"
          onClick={handleAttachmentClick}
          id={ targetId || "attachments"}
         data-attribute="index_Default_Button">
          <img src={ArrowDown} alt="Arrow" title="Arrow down" />
        </OutlineButton>}
      {visible && (
        <Callout
          targetId={ targetId || "attachments"}
          toggleIsCalloutVisible={() => setVisible((prev) => !prev)}
          calloutMaxHeight={280}
         data-attribute="index_Default_Callout">
          <div className="upload-header Attachments-header">
            Attachments
            <Tooltip
              content={tooltipConent || "Allowed file formats are .xlsx, .xls, .doc, .docx, .odt, .ods, .ppt, .pptx, .pdf, .htm, .html, .jpeg, .jpg, .jpe, .jif, .jfif, .jfi, .png, .gif, .webp, .tiff, .tif, .psd. Upload files not more than 5MB. Only 5 files are allowed per Upload."}
             data-attribute="index_Default_Tooltip">
              <span className="fa fa-info-circle attachment-info"></span>
            </Tooltip>
            <EventHandler onEvent={() => setVisible((prev) => !prev)} data-attribute="index_Default_EventHandler_2"><img
              src={close}
              alt="close"
              className="close-btn"              
              />
            </EventHandler>
          </div>

          <div className="upload-attachments">
            {/* drag and drop */}
            <div className="dragDrop">
              <div className="dropzone" onDrop={handleDrop} onDragOver={onDragOver}>
                <div className="draggable-container">
                  <div className="sub-header">Drag & Drop (or) Browse</div>
                  <input
                    type="file"
                    className="file-browser-input"
                    name="file-browser-input"
                    multiple={multiple}
                    onChange={onFileUpload}
                    disabled = {!iAttachmentEditable || disabled}
                    accept={accept}
                   data-attribute="index_file_browser_input_Input" />
                </div>
                <OutlineButton
                  id="uploadBtn"
                  onClick={onUpload}
                  disabled={uploadBtnLoading || !iAttachmentEditable || disabled}
                 data-attribute="index_Default_Button_2">
                  {uploadBtnLoading ? (
                    <Spinner  data-attribute="index_Default_Spinner" />
                  ) : (
                    <span className='pe-2'>Upload</span>
                  )}
                </OutlineButton>
              </div>
              {error && <div className="upload-error-message">{error}</div>}
              {list?.length ? (
                <>
                {!isDownloadable?
                 <div className="file-list">
                   {list.map((file: any, index: any) => {
                     return (
                       <div className="file" key={index}>
                         {OrderRequestType === CONSTANTS.AFEREQUEST && file?.attachmentUrl ? (
                           <EventHandler onEvent={() => { onClickAttachment(file?.attachmentUrl) }} data-attribute={`index_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Open_EventHandler`}>
                             <div className='left-block attachment-left-block'>
                               <a className='attachment-list'>{file?.name || file.fileName}</a>
                             </div>
                           </EventHandler>
                         ) : (
                           <Label title={file.name || file.fileName} data-attribute="index_Default_Label">
                             {file.name || file.fileName}
                           </Label>
                         )}
                         {(file?.isFleet || file?.isFleet == undefined) && iAttachmentEditable && !disabled && !file?.isReceivedAssetImage ?
                           <EventHandler onEvent={() => onRemoveExt(index)} data-attribute={`index_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Remove_EventHandler`}>
                                     <img src={close} alt="close" />
                                 </EventHandler> : null}
                       </div>
                     )
                   })}
                 </div> :
                <div className="file-list">
                {list?.map((file: any, index:any) => {              
                const extensionList = ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'txt', 'bmp', 'webp', 'pdf', 'xlsx', 'heif', 'hevc'];
                const indexExt = file.fileName?.lastIndexOf('.') || file?.name?.lastIndexOf('.')
                const extension = file.fileName?.slice(indexExt + 1) || file?.fileName?.slice(indexExt + 1);
                return (
                  <div className="file" key={index}>
                    {extensionList?.includes(extension?.toString()?.toLowerCase()) ?
                        <EventHandler onEvent={() => { onClickAttachment(file?.attachmentUrl) }} data-attribute={`index_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Download_EventHandler`}>
                                <div className='left-block attachment-left-block'>
                                    <a className='attachment-list'>{file?.name || file.fileName}</a>
                                    {(file?.isFleet || file?.isFleet == undefined) && iAttachmentEditable && !disabled && !file?.isReceivedAssetImage ?
                              <EventHandler onEvent={() => onRemoveExt(index)} data-attribute={`index_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_InnerRemove_EventHandler`}>
                                            <img src={close} alt="close" />
                                        </EventHandler>
                                        : null}
                                </div>
                            </EventHandler> :
                      <div className='left-block attachment-left-block'>
                        <a href={file?.attachmentUrl}>{file?.name || file.fileName}</a>
                        {(file?.isFleet || file?.isFleet == undefined) && iAttachmentEditable && !disabled && !file?.isReceivedAssetImage ?
                              <EventHandler onEvent={() => onRemoveExt(index)} data-attribute={`index_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_FileRemove_EventHandler`}>
                                        <img src={close} alt="close" />
                                    </EventHandler> : null}
                      </div>
                    }
                  </div>)
                })
              }
                </div>
}
                </>
              ) : (
                <div className="no-attachments">No Attachments are uploaded</div>
              )}
            </div>
            {/* drag and drop */}
          </div>
        </Callout>
      )}
    </div>
  )
}
export default AttachmentCommonComponent;